var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.posts),function(post,index){return _c('div',{key:post._id},[(index < 4)?_c('div',[_c('HomePostCardTemplate',{attrs:{"post":post}})],1):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }